import React from 'react'
import { Helmet } from 'react-helmet'

import { useGetSiteUrl } from '@application/Interfaces/Hooks/useGetSiteUrl'
import { BreadcrumbPropsType } from '@application/Types/ComponentTypes'
import { getCompletePath } from '@src/Application/Utils/StringUtility'
import { ensureForwardSlash } from '@src/Infrastructure/Url/ensureForwardSlash'

import { BreadcrumbActive, BreadcrumbLink, BreadcrumbsWrapper } from './Breadcrumb.styled'

export const Breadcrumb = (props: BreadcrumbPropsType): JSX.Element => {
    const { items } = props

    const siteUrl = useGetSiteUrl()

    const cleanItems = items.filter((item) => item.title)

    return (
        <>
            <BreadcrumbsWrapper aria-label="breadcrumb">
                {cleanItems.map((item) => (
                    <React.Fragment key={item.title}>
                        {item.link ? (
                            <>
                                <BreadcrumbLink to={item.link} key={item.title}>
                                    {item.title}
                                </BreadcrumbLink>{' '}
                                /{' '}
                            </>
                        ) : (
                            <BreadcrumbActive key={item.title}>{item.title}</BreadcrumbActive>
                        )}
                    </React.Fragment>
                ))}
            </BreadcrumbsWrapper>
            <Helmet>
                <script type="application/ld+json">
                    {JSON.stringify({
                        '@context': 'https://schema.org/',
                        '@type': 'BreadcrumbList',
                        itemListElement: cleanItems.map((item, index) => {
                            return item.link
                                ? {
                                      '@type': 'ListItem',
                                      position: index + 1,
                                      name: item.title,
                                      item: `${siteUrl}${getCompletePath(ensureForwardSlash(item.link))}`,
                                  }
                                : { '@type': 'ListItem', position: index + 1, name: item.title }
                        }),
                    })}
                </script>
            </Helmet>
        </>
    )
}
